import ClassNames from "classnames";
import { FunctionComponent } from "react";
import style from "../stylesheets/components/spinner.module.css";

const Spinner: FunctionComponent = () => (
  <div className={style.Spinner}>
    <div
      className={ClassNames(style.Spinner__Bounce, style["Spinner__Bounce--1"])}
    ></div>
    <div
      className={ClassNames(style.Spinner__Bounce, style["Spinner__Bounce--2"])}
    ></div>
    <div className={ClassNames(style.Spinner__Bounce)}></div>
  </div>
);

export default Spinner;
